import { ACCESSES, CLAIMACCESSES } from '../constants/access';
import { ClaimType } from '../enum/claims.enum';
import { TIME_CLAIM } from '../enum/time-claim';

export const formatDate = (date: Date) => {
  let d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();
  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;
  return [year, month, day].join('-');
};

export const formatTime = (date: Date) => {
  let d = new Date(date),
    minutes = d.getMinutes(),
    hour = d.getHours(),
    second = '00';
  return [hour, minutes, second].join(':');
};

export const formatDateTime = (date: Date) => {
  let d = new Date(date),
    minutes = d.getMinutes(),
    hour = d.getHours();
  return formatDate(date) + ' ' + [hour, minutes].join(':');
};

export const getClaimType = (modifyTo: number, time: number): ClaimType => {
  const parkingIndex = 0;
  const officeIndex = 1;

  if (modifyTo === CLAIMACCESSES[parkingIndex].id && time == TIME_CLAIM.FULL_DAY) {
    return ClaimType.ADD_FULL_PARKING;
  } else if (
    modifyTo === CLAIMACCESSES[parkingIndex].id &&
    time == TIME_CLAIM.HALF_DAY
  ) {
    return ClaimType.ADD_HALF_PARKING;
  } else if (
    modifyTo === CLAIMACCESSES[officeIndex].id &&
    time == TIME_CLAIM.FULL_DAY
  ) {
    return ClaimType.ADD_FULL_OFFICE;
  } else if (
    modifyTo === CLAIMACCESSES[officeIndex].id &&
    time == TIME_CLAIM.HALF_DAY
  ) {
    return ClaimType.ADD_HALF_OFFICE;
  } else {
    return ClaimType.NONE;
  }
};

export const exportToFile = (headers: any, file: any) => {
	var templateFileName:string = headers.get('content-disposition');
	
	if( templateFileName == null || templateFileName == undefined)
	{
		templateFileName = 'history.csv';	
	}
	else
	{
		// the content-disposition header has the form: 
		// 		attachment; filename="filename.jpg"
		templateFileName = templateFileName.split(';')[1].split('=')[1];
	}
  const url = window.URL.createObjectURL(file);
  const a = document.createElement('a');
  document.body.appendChild(a);
  a.setAttribute('style', 'display: none');
  a.href = url;
  a.download = templateFileName;
  a.target = '_self';
  a.click();
  window.URL.revokeObjectURL(url);
  a.remove();
}

export const groupBy = <T, K extends keyof any>(arr: T[], key: (i: T) => K) =>
arr.reduce((groups, item) => {
  (groups[key(item)] ||= []).push(item);
  return groups;
}, {} as Record<K, T[]>);


export function logHeader(separator:string=" -- "): string {
	let t = new Date();
	return t.toISOString()+separator;
}

export function logEx(message?: any, ...optionalParams: any[]):void {
	if( optionalParams && optionalParams.length != 0)
	{
		console.log( logHeader(), message, optionalParams);
	}
	else
	{
		console.log( logHeader(), message);
	}
}

export function errorEx(message?: any, ...optionalParams: any[]):void {
	if( optionalParams && optionalParams.length != 0)
	{
		console.error( logHeader(), message, optionalParams);
	}
	else
	{
		console.error( logHeader(), message);
	}
}

export function traceEx(message?: any, ...optionalParams: any[]):void {
	if( optionalParams && optionalParams.length != 0)
	{
		console.trace( logHeader(), message, optionalParams);
	}
	else
	{
		console.trace( logHeader(), message);
	}
}

declare global {
	export type NoParamStringFunction = () => string;
	export type ConsoleLogFunction = (message?: any, ...optionalParams: any[]) => void;

	interface Console {
		isoHeader:NoParamStringFunction;
		logEx(message?: any, ...optionalParams: any[]):void;
		infoEx(message?: any, ...optionalParams: any[]):void;
		errorEx(message?: any, ...optionalParams: any[]):void;
		warnEx(message?: any, ...optionalParams: any[]):void;
		traceEx(message?: any, ...optionalParams: any[]):void;
		debugEx(message?: any, ...optionalParams: any[]):void;
	}
}

export function AugmentConsole():void {
	console.isoHeader = logHeader;
	console.logEx = logEx;
	console.debugEx = logEx;
	console.infoEx = logEx;
	console.errorEx = errorEx;
	console.warnEx = errorEx;
}
